import type {ReactNode} from 'react'

export function WarningPill({children}: {children: ReactNode}) {
    return (
        <span className='font-mono text-[11px] tracking-[0.15em] uppercase px-3 py-1 bg-destructive/10 text-destructive border border-destructive/30'>
            {children}
        </span>
    )
}
